import { render } from "./feed.html?vue&type=template&id=657eed1e&external"
import script from "./feed.js?vue&type=script&lang=js&external"
export * from "./feed.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__